import { render, staticRenderFns } from "./SosCaseMain.vue?vue&type=template&id=2ec9b34a&scoped=true"
import script from "./SosCaseMain.vue?vue&type=script&lang=js"
export * from "./SosCaseMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9b34a",
  null
  
)

export default component.exports